import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import {
  LuAlignHorizontalJustifyCenter,
  LuCalendarClock,
  LuCalendarDays,
  LuKeyboard,
} from "react-icons/lu";
import { GrServices } from "react-icons/gr";
import { TbClock24, TbClockCheck } from "react-icons/tb";
import {
  MdApproval,
  MdDeleteOutline,
  MdOutlineFormatSize,
  MdOutlineTipsAndUpdates,
} from "react-icons/md";
import Testimonial from "../components/Sections/Testimonial";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { animateScroll as scroll } from "react-scroll";
import axios from "axios";
import { HashLoader } from "react-spinners";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { GoCodescanCheckmark } from "react-icons/go";
import { ErrorAlert } from "../components/Elements/SweetAlerts";

let jobDesc1 =
  "Key Responsibilities: Develop and enhance user-facing features using JavaScript, HTML5, and CSS3. Build reusable code and libraries for future use. Ensure technical feasibility of UI/UX designs. Optimize applications for maximum speed and scalability. Validate user input before submitting to back-end services. Collaborate with back-end developers and designers. Debug, test, and maintain existing projects. Integrate third-party services and APIs as needed. Required Skills & Qualifications: Proficient in core JavaScript (ES6+), including asynchronous programming and DOM manipulation. Experience with at least one modern JavaScript framework (e.g., React, Angular, Vue.js). Familiarity with AJAX, JSON, and RESTful APIs. Understanding of cross-browser compatibility issues and solutions. Experience with version control systems (e.g., Git). Basic understanding of front-end build tools (e.g., Webpack, Gulp). Bachelor’s degree in Computer Science or related field preferred.";
let jobDesc2 =
  "Key Responsibilities: Write clean, efficient, and reusable Python code. Develop server-side logic and integrate user-facing elements with server-side logic. Build and maintain web applications using frameworks like Django or Flask. Integrate data storage solutions (e.g., MySQL, PostgreSQL). Test and debug applications to ensure high performance and reliability. Collaborate with front-end developers and other team members. Maintain technical documentation and participate in code reviews. Stay updated with latest Python technologies and best practices. Required Skills & Qualifications: Strong proficiency in Python and understanding of OOP concepts. Experience with at least one Python web framework (Django, Flask, etc.). Familiarity with relational databases and ORM libraries. Basic knowledge of front-end technologies (HTML, CSS, JavaScript). Experience with version control systems (Git). Good problem-solving and communication skills. Bachelor’s degree in Computer Science or related field preferred.";
let jobDesc3 =
  "Key Responsibilities: Develop, test, and maintain web applications using PHP. Write clean, scalable, and well-documented code. Collaborate with front-end developers to integrate user-facing elements. Troubleshoot, debug, and optimize existing applications. Work with databases (e.g., MySQL), and manage data exchange between server and users. Participate in code reviews and contribute to best practices]. Stay updated with emerging technologies and apply them to ongoing projects. Required Skills & Qualifications: Proficient in PHP and understanding of OOP principles. Experience with PHP frameworks (e.g., Laravel, CodeIgniter). Familiarity with front-end technologies (HTML, CSS, JavaScript). Understanding of SQL and relational databases. Experience with version control systems (Git). Strong problem-solving skills and attention to detail. Bachelor’s degree in Computer Science or related field preferred.";

let demoUrl1 =
  "https://writing.colostate.edu/guides/documents/resume/functionalsample.pdf";
let demoUrl2 =
  "https://writing.colostate.edu/guides/documents/resume/functionalsample.pdf";
let demoUrl3 =
  "https://writing.colostate.edu/guides/documents/resume/functionalsample.pdf";

const ATSPage = () => {
  const history = useHistory();
  const [isDragging, setIsDragging] = useState(false);
  const fileInputRef = useRef(null);
  const [tryResumeName, setTryResumeName] = useState("");
  const [tryResumeURL, setTryResumeURL] = useState("");

  // ATS Result
  const [loading, setLoading] = useState(false);
  const [score, setScore] = useState("");
  const [improvements, setImprovements] = useState([]);
  const [strengths, setStrengths] = useState([]);
  const [weaknesses, setWeaknesses] = useState([]);

  const initialValues = {
    jobDescription: "",
    resumeFile: null,
  };

  useEffect(() => {
    scroll.scrollToTop();
  }, []);

  /**
   * Validation schema for the form using Yup
   * - Job description is required and must be at least 50 characters
   * - Resume file is required and must be PDF, DOC, or DOCX format
   */
  const FILE_SIZE = 3000000; // 3MB
  const SUPPORTED_FORMATS = [
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ];
  const validationSchema = Yup.object().shape({
    jobDescription: Yup.string()
      .required("Job description is required")
      .min(50, "Job description should be at least 50 characters"),
    resumeFile: Yup.mixed()
      .nullable()
      .notRequired()
      .test(
        "fileSize",
        "File size too large",
        (value) => !value || (value && value.size <= FILE_SIZE)
      )
      .test(
        "fileFormat",
        "Unsupported file format",
        (value) => !value || (value && SUPPORTED_FORMATS.includes(value.type))
      ),
    // .test(
    //   "fileFormat",
    //   "Unsupported file format. Please upload PDF, DOC, or DOCX files only.",
    //   (value) => {
    //     if (!value) return false;
    //     const supportedFormats = [
    //       "application/pdf",
    //       "application/msword",
    //       "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    //     ];
    //     return (
    //       supportedFormats.includes(value.type) ||
    //       value.name.endsWith(".pdf") ||
    //       value.name.endsWith(".doc") ||
    //       value.name.endsWith(".docx")
    //     );
    //   }
    // ),
  });

  const handleSubmit = (values, { setSubmitting }) => {
    console.log("Form submitted with values:", values);
    setLoading(true);
    const formData = new FormData();
    formData.append("jobDescription", values.jobDescription);
    if (values.resumeFile) {
      formData.append("resumeFile", values.resumeFile);
      formData.append("is_resume_file", true);
    } else {
      formData.append("resumeUrl", tryResumeURL);
      formData.append("is_resume_file", false);
    }
    for (const value of formData.values()) {
      console.log("🚀 ~ ATSPage.jsx:108 ~ handleSubmit ~ value:", value);
    }

    setTimeout(async () => {
      // "https://hook.us2.make.com/h4ih3p4si4edzqnax4242yhiopm4vymu",
      // "https://hook.us2.make.com/9ryikaxieq0sga63ovldukkijph3nhng" // last
      try {
        const response = await axios.post(
          "https://test.ct-n8n.ctserver.space/webhook/ats",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        let data = response.data;

        // Handle nested JSON string (e.g. from Gemini/AI responses)
        if (data?.content?.parts?.[0]?.text) {
          try {
            data = JSON.parse(data.content.parts[0].text);
          } catch (e) {
            console.error("Failed to parse nested response text:", e);
          }
        } else if (typeof data === "string") {
          try {
            data = JSON.parse(data);
          } catch (e) {
            console.error("Failed to parse response string:", e);
          }
        }

        if (data.ats_score !== undefined) {
          setScore(data.ats_score);
        }
        if (data.improvements || data.improvement) {
          setImprovements(data.improvements || data.improvement);
        }
        if (data.strengths || data.strength) {
          setStrengths(data.strengths || data.strength);
        }
        if (data.weaknesses || data.weakness) {
          setWeaknesses(data.weaknesses || data.weakness);
        }

        setSubmitting(false);
        setLoading(false);
      } catch (error) {
        console.error("Error uploading:", error);
        ErrorAlert();
        setLoading(false);
      }
    }, 1000);
  };

  const handleFileChange = (event, setFieldValue) => {
    if (event.currentTarget.files && event.currentTarget.files[0]) {
      const file = event.currentTarget.files[0];
      setFieldValue("resumeFile", file);
    }
  };

  // Drag and drop handlers
  const handleDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!isDragging) {
      setIsDragging(true);
    }
  };

  const handleDrop = (e, setFieldValue, setFieldTouched) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);

    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      const file = e.dataTransfer.files[0];

      // Validate file type
      const supportedFormats = [
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      ];
      const isValidType =
        supportedFormats.includes(file.type) ||
        file.name.endsWith(".pdf") ||
        file.name.endsWith(".doc") ||
        file.name.endsWith(".docx");

      if (isValidType) {
        setFieldValue("resumeFile", file);
      } else {
        alert("Please upload only PDF, DOC, or DOCX files");
      }

      setFieldTouched("resumeFile", true, true);
    }
  };

  const handleBrowseClick = () => {
    fileInputRef.current.click();
  };

  const handleTryResume = (demoUrl) => {
    setTryResumeName(demoUrl.split("/").pop());
    setTryResumeURL(demoUrl);
  };

  const handleViewResume = (demoUrl) => {
    window.open(demoUrl, "_blank");
  };

  const handleDeleteResume = (e, setFieldValue) => {
    if (tryResumeName !== "") {
      setTryResumeName("");
      setTryResumeURL("");
    } else {
      setFieldValue("resumeFile", null);
    }
  };

  const handleTryJobDesc = (count, setFieldValue) => {
    if (count === "try-1") setFieldValue("jobDescription", jobDesc1);
    if (count === "try-2") setFieldValue("jobDescription", jobDesc2);
    if (count === "try-3") setFieldValue("jobDescription", jobDesc3);
  };

  const getBarColor = (score) => {
    if (score < 50) return "#ff3860"; // Red
    if (score < 75) return "#ff9800"; // Orange
    // return "#4caf50"; // Green
    return "#49CB86";
  };

  return (
    <>
      <Wrapper className="flexNullCenter flexColumn">
        <HeroContainer>
          <ContentWrapper>
            <TextContent>
              <Title>Resume ATS Score Analyzer</Title>
              <Description>
                Instantly evaluate your resume's compatibility with Applicant
                Tracking Systems. Our AI-powered tool analyzes your resume
                against job descriptions to maximize your chances of getting
                past automated screening systems and into the hands of
                recruiters.
              </Description>
            </TextContent>
          </ContentWrapper>
          {/* <DemoWrapper>
            <DemoDiv>
              <DescSectionDiv>
                <CardTitle>Job Description *</CardTitle>
                <TextAreaWrapper>
                  <StyledTextArea
                    value={jobDescription}
                    onChange={(e) => setJobDescription(e.target.value)}
                    placeholder="Write your job description here..."
                  />
                </TextAreaWrapper>
              </DescSectionDiv>
              <ResumeSectionDiv>
                <CardTitle>Upload Your Resume *</CardTitle>
                <UploadAreaWrapper
                  onDragEnter={handleDragEnter}
                  onDragOver={handleDragOver}
                  onDragLeave={handleDragLeave}
                  onDrop={handleDrop}
                  isDragging={isDragging}
                  onClick={handleBrowseClick}
                >
                  <HiddenFileInput
                    type="file"
                    ref={fileInputRef}
                    onChange={handleFileChange}
                    accept=".pdf,.doc,.docx"
                  />
                  <UploadText>
                    {selectedFile
                      ? selectedFile.name
                      : "Choose File: No file chosen"}
                  </UploadText>
                </UploadAreaWrapper>
              </ResumeSectionDiv>
            </DemoDiv>
          </DemoWrapper> */}
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({
              values,
              errors,
              touched,
              isSubmitting,
              setFieldValue,
              setFieldTouched,
            }) => (
              <Form style={{ width: "100%" }}>
                <DemoWrapper>
                  <DemoDiv>
                    <DescSectionDiv>
                      <CardTitle>Job Description *</CardTitle>
                      <TextAreaWrapper>
                        <ErrorMessageStyled
                          name="jobDescription"
                          component="div"
                        />
                        <Field
                          as={StyledTextArea}
                          name="jobDescription"
                          placeholder="Write your job description here..."
                        />
                      </TextAreaWrapper>
                      <ResumeOptionDiv>
                        <p>Try one of these job description:</p>

                        <ResumeOptionsContainer>
                          <ResumeOption>
                            <ResumeTitle>Sample 1</ResumeTitle>
                            <ButtonContainer>
                              <TryButton
                                type="button"
                                onClick={() =>
                                  handleTryJobDesc("try-1", setFieldValue)
                                }
                              >
                                Try it
                              </TryButton>
                            </ButtonContainer>
                          </ResumeOption>

                          <ResumeOption>
                            <ResumeTitle>Sample 2</ResumeTitle>
                            <ButtonContainer>
                              <TryButton
                                type="button"
                                onClick={() =>
                                  handleTryJobDesc("try-2", setFieldValue)
                                }
                              >
                                Try it
                              </TryButton>
                            </ButtonContainer>
                          </ResumeOption>

                          <ResumeOption>
                            <ResumeTitle>Sample 3</ResumeTitle>
                            <ButtonContainer>
                              <TryButton
                                type="button"
                                onClick={() =>
                                  handleTryJobDesc("try-3", setFieldValue)
                                }
                              >
                                Try it
                              </TryButton>
                            </ButtonContainer>
                          </ResumeOption>
                        </ResumeOptionsContainer>
                      </ResumeOptionDiv>
                    </DescSectionDiv>

                    <ResumeSectionDiv>
                      <CardTitle>
                        Upload Your Resume *{" "}
                        {(values.resumeFile || tryResumeName !== "") && (
                          <DeleteResume
                            onClick={(e) =>
                              handleDeleteResume(e, setFieldValue)
                            }
                          />
                        )}
                      </CardTitle>
                      <ErrorMessageStyled name="resumeFile" component="div" />
                      <UploadAreaWrapper
                        onDragEnter={handleDragEnter}
                        onDragOver={handleDragOver}
                        onDragLeave={handleDragLeave}
                        onDrop={(e) =>
                          handleDrop(e, setFieldValue, setFieldTouched)
                        }
                        isDragging={isDragging}
                        onClick={handleBrowseClick}
                        hasError={touched.resumeFile && errors.resumeFile}
                      >
                        <HiddenFileInput
                          type="file"
                          ref={fileInputRef}
                          onChange={(e) => handleFileChange(e, setFieldValue)}
                          accept=".pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                        />
                        <UploadText>
                          {values.resumeFile
                            ? values.resumeFile.name
                            : tryResumeName
                            ? tryResumeName
                            : "Drag & Drop --- OR --- Select a File"}
                        </UploadText>
                      </UploadAreaWrapper>

                      <ResumeOptionDiv>
                        <p>No Resumes? Try one of these:</p>

                        <ResumeOptionsContainer>
                          <ResumeOption>
                            <ResumeTitle>Resume 1</ResumeTitle>
                            <ButtonContainer>
                              <TryButton
                                type="button"
                                onClick={() => handleTryResume(demoUrl1)}
                              >
                                Try it
                              </TryButton>
                              <ViewButton
                                onClick={() => handleViewResume(demoUrl1)}
                              >
                                View
                              </ViewButton>
                            </ButtonContainer>
                          </ResumeOption>

                          <ResumeOption>
                            <ResumeTitle>Resume 2</ResumeTitle>
                            <ButtonContainer>
                              <TryButton
                                type="button"
                                onClick={() => handleTryResume(demoUrl2)}
                              >
                                Try it
                              </TryButton>
                              <ViewButton
                                onClick={() => handleViewResume(demoUrl2)}
                              >
                                View
                              </ViewButton>
                            </ButtonContainer>
                          </ResumeOption>

                          <ResumeOption>
                            <ResumeTitle>Resume 3</ResumeTitle>
                            <ButtonContainer>
                              <TryButton
                                type="button"
                                onClick={() => handleTryResume(demoUrl3)}
                              >
                                Try it
                              </TryButton>
                              <ViewButton
                                onClick={() => handleViewResume(demoUrl3)}
                              >
                                View
                              </ViewButton>
                            </ButtonContainer>
                          </ResumeOption>
                        </ResumeOptionsContainer>
                      </ResumeOptionDiv>
                    </ResumeSectionDiv>
                  </DemoDiv>

                  <SubmitButtonWrapper>
                    <SubmitButton type="submit" disabled={loading}>
                      {loading ? "Analyzing..." : "Analyze Resume"}
                    </SubmitButton>
                  </SubmitButtonWrapper>

                  {loading ? (
                    <div
                      style={{
                        padding: "50px 0px",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <HashLoader
                        color="#7620ff"
                        loading={loading}
                        size={150}
                        aria-label="Loading Spinner"
                        data-testid="loader"
                      />
                    </div>
                  ) : (
                    <div>
                      <Container>
                        <hr />
                        <div style={{ width: "100%" }}>
                          {score && score !== "" && (
                            <ScoreContainer>
                              <ScoreLabel>Your Score</ScoreLabel>
                              <GaugeWrapper>
                                <CircularProgressbar
                                  value={score}
                                  maxValue={100}
                                  text={""}
                                  circleRatio={0.5}
                                  styles={buildStyles({
                                    rotation: 0.75,
                                    strokeLinecap: "butt",
                                    trailColor: "#eaeaea",
                                    pathColor: getBarColor(score),
                                    textColor: getBarColor(score),
                                    pathTransitionDuration: 0.5,
                                  })}
                                />
                              </GaugeWrapper>
                              <ScoreValue>{score}/100</ScoreValue>
                            </ScoreContainer>
                          )}

                          <div style={{ padding: "20px 0px" }}>
                            {improvements && improvements.length > 0 && (
                              <SectionTitle>Improvements:</SectionTitle>
                            )}
                            <List>
                              {improvements.map((item, i) => (
                                <ListItem key={i}>{item}</ListItem>
                              ))}
                            </List>
                          </div>
                        </div>
                        <div style={{ display: "flex", width: "100%" }}>
                          <div style={{ width: "50%" }}>
                            {strengths && strengths.length > 0 && (
                              <SectionTitle>Strengths:</SectionTitle>
                            )}
                            <List>
                              {strengths.map((item, i) => (
                                <ListItem key={i}>{item}</ListItem>
                              ))}
                            </List>
                          </div>
                          <div style={{ width: "50%" }}>
                            {weaknesses && weaknesses.length > 0 && (
                              <SectionTitle>Weaknesses:</SectionTitle>
                            )}
                            <List>
                              {weaknesses.map((item, i) => (
                                <ListItem key={i}>{item}</ListItem>
                              ))}
                            </List>
                          </div>
                        </div>
                      </Container>
                    </div>
                  )}
                </DemoWrapper>
              </Form>
            )}
          </Formik>
        </HeroContainer>
      </Wrapper>

      <DemoSampleWrapper className="lightBg">
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold">Features</h1>
            <p className="font13">
              Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
              nonumy eirmod tempor invidunt ut
              <br />
              labore et dolore magna aliquyam erat, sed diam voluptua.
            </p>
          </HeaderInfo>
          <DemoSampleWrapperDiv>
            <FeatureWrapper className="whiteBg radius8 shadow">
              <DemoFeatureDiv>
                <DemoFeatureIcon>
                  <LuKeyboard fontSize={26} />
                </DemoFeatureIcon>
                <DemoFeatureTitle className="font20 extraBold">
                  Resume Parsing and Keyword Analysis
                </DemoFeatureTitle>
              </DemoFeatureDiv>
              <DemoFeatureDesc className="font13">
                Automatically extracts and analyzes resume content to identify
                key information including skills, experience, and
                qualifications.
              </DemoFeatureDesc>
            </FeatureWrapper>
            <FeatureWrapper className="whiteBg radius8 shadow">
              <DemoFeatureDiv>
                <DemoFeatureIcon>
                  <LuAlignHorizontalJustifyCenter fontSize={26} />
                </DemoFeatureIcon>
                <DemoFeatureTitle className="font20 extraBold">
                  Job Description Alignment
                </DemoFeatureTitle>
              </DemoFeatureDiv>
              <DemoFeatureDesc className="font13">
                Upload job descriptions to compare against your resume,
                Identifies gaps between your resume content and job
                requirements.
              </DemoFeatureDesc>
            </FeatureWrapper>
            <FeatureWrapper className="whiteBg radius8 shadow">
              <DemoFeatureDiv>
                <DemoFeatureIcon>
                  <GoCodescanCheckmark fontSize={26} />
                </DemoFeatureIcon>
                <DemoFeatureTitle className="font20 extraBold">
                  Quantifiable Achievement Scanner
                </DemoFeatureTitle>
              </DemoFeatureDiv>
              <DemoFeatureDesc className="font13">
                Identifies and highlights quantifiable achievements in your
                resume.
              </DemoFeatureDesc>
            </FeatureWrapper>
            <FeatureWrapper className="whiteBg radius8 shadow">
              <DemoFeatureDiv>
                <DemoFeatureIcon>
                  <MdOutlineFormatSize fontSize={26} />
                </DemoFeatureIcon>
                <DemoFeatureTitle className="font20 extraBold">
                  Resume Formatting Feedback
                </DemoFeatureTitle>
              </DemoFeatureDiv>
              <DemoFeatureDesc className="font13">
                Many resumes fail ATS scans due to formatting errors. Our tool
                checks for file type compatibility.
              </DemoFeatureDesc>
            </FeatureWrapper>
            <FeatureWrapper className="whiteBg radius8 shadow">
              <DemoFeatureDiv>
                <DemoFeatureIcon>
                  <MdApproval fontSize={26} />
                </DemoFeatureIcon>
                <DemoFeatureTitle className="font20 extraBold">
                  Language & Tone Optimization
                </DemoFeatureTitle>
              </DemoFeatureDiv>
              <DemoFeatureDesc className="font13">
                Avoid passive language and overused buzzwords. The analyzer
                reviews your sentence structure, verb usage, and tone—helping
                you present yourself with clarity and authority.
              </DemoFeatureDesc>
            </FeatureWrapper>
            <FeatureWrapper className="whiteBg radius8 shadow">
              <DemoFeatureDiv>
                <DemoFeatureIcon>
                  <MdOutlineTipsAndUpdates fontSize={26} />
                </DemoFeatureIcon>
                <DemoFeatureTitle className="font20 extraBold">
                  Overall ATS Score & Improvement Tips
                </DemoFeatureTitle>
              </DemoFeatureDiv>
              <DemoFeatureDesc className="font13">
                Receive a detailed breakdown of your ATS compatibility score
                with personalized suggestions.
              </DemoFeatureDesc>
            </FeatureWrapper>
          </DemoSampleWrapperDiv>
        </div>
      </DemoSampleWrapper>

      {/* Testimonial */}
      <Testimonial />
    </>
  );
};

const Wrapper = styled.section`
  width: 100%;
  max-width: 1220px;
  margin: 0 auto;
  padding: 110px 30px 0px 30px;
  @media (max-width: 960px) {
    flex-direction: column;
  }
`;

const HeroContainer = styled.section`
  background-color: #f9fafb;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 32px;
`;

const ContentWrapper = styled.div`
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 32px;

  @media (max-width: 1024px) {
    flex-direction: column;
    text-align: center;
  }
`;

const TextContent = styled.div`
  flex: 1;
  min-width: 300px;
  text-align: center;
`;

const Title = styled.h1`
  font-size: 36px;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 12px;
`;

const Description = styled.p`
  font-size: 18px;
  color: #6b7280;
  margin-bottom: 32px;
  line-height: 2;
`;

const DemoSampleWrapper = styled.div`
  margin-top: 50px;
  padding: 50px 0px;
`;

const HeaderInfo = styled.div`
  margin-bottom: 30px;
  @media (max-width: 860px) {
    text-align: center;
  }
`;

const DemoSampleWrapperDiv = styled.div`
  width: 100%;
  max-width: 1220px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;

const FeatureWrapper = styled.div`
  width: 350px;
  height: 220px;
  text-align: left;
  padding: 20px 30px;
  margin: 30px 0px;
  transition: transform 0.3s, box-shadow 0.3s;

  &:hover {
    transform: scale(1.05) translateY(-5px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18);
  }
`;

const DemoFeatureDiv = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

const DemoFeatureIcon = styled.div`
  width: 30%;
  width: 60px;
  height: 60px;
  background-color: #f3f4f6;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;
`;

const DemoFeatureTitle = styled.h3`
  width: 70%;
  padding: 10px 15px;
`;

const DemoFeatureDesc = styled.p`
  padding: 10px 0px;
`;

const DemoWrapper = styled.div`
  width: 100%;
`;

const DemoDiv = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
`;

const DescSectionDiv = styled.div`
  width: 45%;
  height: auto;
  min-height: 400px;
  box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1);
  background: #fff;
  border-radius: 12px;
  border-top: 12px solid #7620ff;
  padding: 32px;
`;
const ResumeSectionDiv = styled.div`
  width: 45%;
  height: auto;
  min-height: 400px;
  box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1);
  background: #fff;
  border-radius: 12px;
  border-top: 12px solid #7620ff;
  padding: 32px;
`;

const CardTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const DeleteResume = styled(MdDeleteOutline)`
  font-size: 24px;
  cursor: pointer;
  color: #ff3860;
`;

const TextAreaWrapper = styled.div`
  width: 100%;
`;

const StyledTextArea = styled.textarea`
  width: 100%;
  min-height: 140px;
  max-height: 240px;
  padding: 12px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  font-size: 14px;
  resize: vertical;
  outline: none;
  box-sizing: border-box;

  &:focus {
    border-color: #7620ff;
    box-shadow: 0 0 0 2px rgba(33, 150, 243, 0.1);
  }

  &::placeholder {
    color: #9e9e9e;
  }
`;

const UploadAreaWrapper = styled.div`
  position: relative;
  width: 100%;
  min-height: 140px;
  border: ${(props) =>
    props.hasError
      ? "2px dashed #ff3860"
      : props.isDragging
      ? "2px dashed #7620ff"
      : "1px solid #ddd"};
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) =>
    props.hasError
      ? "rgba(255, 56, 96, 0.05)"
      : props.isDragging
      ? "rgba(118, 32, 255, 0.05)"
      : "#fff"};
  transition: all 0.2s ease;
  cursor: pointer;
  box-sizing: border-box;

  &:hover {
    border-color: ${(props) => (props.hasError ? "#ff3860" : "#7620ff")};
    background-color: ${(props) =>
      props.hasError ? "rgba(255, 56, 96, 0.05)" : "rgba(118, 32, 255, 0.05)"};
  }
`;

const HiddenFileInput = styled.input`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
  z-index: -1;
`;

const UploadText = styled.div`
  font-size: 14px;
  color: #666;
  text-align: center;
  padding: 0 15px;
`;

const ResumeOptionDiv = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 20px 0px;
`;

const ResumeOptionsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
  width: 100%;
`;

const ResumeOption = styled.div`
  width: 30%;
  text-align: center;
`;

const ResumeTitle = styled.div`
  font-size: 14px;
  margin-bottom: 5px;
  color: #333;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 5px;
  justify-content: center;
`;

// Try button styling
const TryButton = styled.button`
  background-color: #7620ff;
  color: #fff;
  border: none;
  border-radius: 3px;
  padding: 4px 10px;
  cursor: pointer;
  font-size: 12px;

  &:hover {
    background-color: #6010e2;
  }
`;

// View button styling
const ViewButton = styled.button`
  background-color: #fff;
  color: #7620ff;
  border: 1px solid #7620ff;
  border-radius: 3px;
  padding: 4px 10px;
  cursor: pointer;
  font-size: 12px;

  // &:hover {
  //   background-color: #6010e2;
  // }
`;

const ErrorMessageStyled = styled(ErrorMessage)`
  color: #ff3860;
  font-size: 12px;
  margin-top: 5px;
  font-weight: 500;
`;

const SubmitButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 30px;
`;

const SubmitButton = styled.button`
  background-color: #7620ff;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s, transform 0.2s;
  box-shadow: 0 4px 6px rgba(118, 32, 255, 0.2);

  &:hover {
    background-color: #6010e2;
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    background-color: #b794f6;
    cursor: not-allowed;
    transform: none;
  }
`;

const Container = styled.div`
  padding: 2rem;
  margin: auto;
  font-family: "Segoe UI", sans-serif;
`;

const SectionTitle = styled.h2`
  padding-bottom: 10px;
  margin-top: 16px;
`;

const List = styled.ul`
  list-style: disc;
  padding-left: 1.5rem;
`;

const ListItem = styled.li`
  margin-bottom: 0.5rem;
`;

const ScoreContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px 0px;
`;

const ScoreLabel = styled.div`
  font-size: 30px;
  font-weight: 800;
  margin-bottom: 16px;
  color: #7620ff;
`;

const ScoreValue = styled.div`
  font-size: 2rem;
  font-weight: bold;
  color: #ff5e6c;
  margin-top: 12px;
`;

const GaugeWrapper = styled.div`
  width: 330px;
  height: 120px;
  margin-bottom: 0;
`;

export default ATSPage;
